/**
 * Odświeża badge z liczbą pozycji w koszyku przez Woo AJAX.
 */
let refreshRequest = null;

const applyCartCountFromFragments = (fragments = null) => {
    const badge = document.querySelector('span.header-cart-count');
    if (!badge) return false;

    const fragmentHtml = fragments?.['span.header-cart-count'];
    if (!fragmentHtml) return false;

    const temp = document.createElement('div');
    temp.innerHTML = fragmentHtml;
    const newBadge = temp.querySelector('span.header-cart-count');
    if (!newBadge) return false;

    badge.replaceWith(newBadge);
    return true;
};

const refreshCartCount = () => {
    const badge = document.querySelector('span.header-cart-count');
    if (!badge) return Promise.resolve();

    if (refreshRequest) {
        return refreshRequest;
    }

    const params =
        window.wc_cart_fragments_params || window.woocommerce_params || {};
    const ajaxUrl = params.wc_ajax_url
        ? params.wc_ajax_url.replace('%%endpoint%%', 'get_refreshed_fragments')
        : '/?wc-ajax=get_refreshed_fragments';

    refreshRequest = fetch(ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
    })
        .then(response => response.json())
        .then(data => {
            applyCartCountFromFragments(data?.fragments || null);
        })
        .catch(() => {});

    refreshRequest.finally(() => {
        refreshRequest = null;
    });

    return refreshRequest;
};

/**
 * Podpina odświeżanie licznika do zdarzeń WooCommerce.
 */
const initCartCountRefresh = () => {
    if (window.jQuery) {
        const $body = window.jQuery(document.body);
        const onCartEvent = (event, fragments = null) => {
            if (applyCartCountFromFragments(fragments)) {
                return;
            }
            refreshCartCount();
        };

        $body.on(
            'added_to_cart removed_from_cart wc_fragments_refreshed updated_cart_totals wc_cart_emptied',
            onCartEvent
        );
        return;
    }

    document.body.addEventListener('click', event => {
        const target = event.target.closest('a.remove');
        if (!target) return;
        window.setTimeout(refreshCartCount, 600);
    });
};

initCartCountRefresh();
